/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
let n=null;function t(){return n}async function e(){n=await import("../../../../../../../geometry/geometryEngineJSON.js")}export{t as getGeometryEngine,e as loadGeometryEngine};
